<template>
	<v-container pa-0>
	<v-container fluid pa-0 ma-0 class="footer">
		<v-layout row wrap justify-center>
			<v-flex xs12 mb-4>
				<v-card flat class="slogan">
					Elizabeth Anne Sauer, BBA 1966, Structural Biology Laboratory, in honor of Judy Camp Sauer, BA Biology 1964
				</v-card>
			</v-flex>
			<v-flex xs10 sm7 md4 text-xs-center text-md-left px-4>
				<v-layout>
					<v-card flat class="footer-content footer-content-left">
						<h3>
							Laboratory
						</h3>
						<p>
							<strong> Faulkner Nanoscience and<br>Technology (FNT) </strong>
							<br>
							<strong>B.107</strong>
							<br>
							102 E. 24th St.
							<br>
							Austin, TX 78712
						</p>
						<p>
							Website Problems?
							<a href="mailto:itsvanka@gmail.com">Contact Us</a>
						</p>
					</v-card>
					<v-card class="hidden-sm-and-down border-crutch">
					</v-card>
				</v-layout>
			</v-flex>
			<v-flex xs10 sm7 md3 text-xs-center text-md-left px-4>
				<v-card flat class="footer-content">
					<h3>
						Contact
					</h3>
					<ul>
						<li>P: <a href="tel://512-475-6487">512-475-6487</a></li><!--
						--><li>P: <a href="tel://512-475-6488">512-475-6488</a></li><!--
						--><li><a href="mailto:axel.brilot@austin.utexas.edu">Email Facility Manager</a></li><!--
						--><li><router-link to="/contactinfo">Contact Details</router-link></li>
					</ul>
				</v-card>
			</v-flex>
			<v-flex xs10 sm7 md5 text-xs-center text-md-left px-4>
				<v-card flat class="footer-content">
					<h3>
						Helpful Links
					</h3>
					<ul class="footer-links">
						<li><a href="http://utexas.edu">UT Austin Home</a></li><!--
						--><li><a href="http://utexas.edu/emergency">Emergency Information</a></li><!--
						--><li><a href="http://utexas.edu/site-policies">Site Policies</a></li><!--
						--><li><a href="http://utexas.edu/web-accessibility-policy">Web Accessibility Policy</a></li><!--
						--><li><a href="http://utexas.edu/web-privacy-policy">Web Privacy Policy</a></li><!--
						--><li><a href="https://get.adobe.com/reader/">Adobe Reader</a></li>
					</ul>
				</v-card>
			</v-flex>
			<v-flex xs12>
				<v-card flat class="copyright px-5 pb-2">
					© Ivan Chernyshov, Patrick Goetz, and David Taylor, The University of Texas at Austin 2022
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
	</v-container>
	
</template>

<script>
export default {
  name: 'footer',
  data () {
    return {
	
    }
  },
  methods:{
		
	}
}
</script>

<style scoped>
.footer{
	background-color:#f8f8f8;
}
.footer div{
	border-radius:0px;
}
.footer-content{
	background-color:transparent;
	font-family: "open_sans", sans-serif;
	font-size: 14.5px;
	line-height: 21px;
	color: #515151;
	font-weight:400;
	margin:15px;
	display:inline-block;
}
.footer-content-left{
	width:100%;
}
.footer-content h3{
	color: #2d2a28;
	margin-bottom:13px;
	font-weight:600;
	font-size:18px;
}
.footer-content p{
	margin-bottom:20px;
}
.footer-content ul{
	list-style: none;
	display:inline-block;
}
.footer-content a{
	color: #333333;
	text-decoration: none;
	padding:7px 0px 7px 0px;
	margin-bottom:10px;
}
.footer-content a:hover{
	color: #bf5700;
	text-decoration: underline;
}
.footer-content ul li{
	margin-bottom: 5px;
}
.footer-links li{
	display:inline-block;
	margin-bottom:20px !important;
	width:180px;
}
.border-crutch{
	width:1px;
	border-radius: 0px;
	background-color:#cbcbcb;;
	margin:20px 0 20px 0;
}
.slogan{
	color: #2d2a28;
	font-size: 21px;
	padding:5px 10px 5px 10px;
	text-align: center;
	background-color:#ebe8e2;
	display:block;
}
.copyright{
	font-style:italic;
	background-color:transparent;
	font-family: "open_sans", sans-serif;
	color: #515151;
	font-weight:400;
	font-size: 14.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue